export const content = {
  headingLine1: 'Less Malarkey',
  headingLine2: 'More SMARTY',
  topBannerText:
    "At SMARTY, we don't believe in needless complexity. That's why we offer SIM only plans with no contract, no annual price rises, 5G and EU Roaming (up to 12GB) included at no extra cost, all with unlimited calls and texts.",
  bottomBannerText:
    "We believe in brilliant simplicity and strive to call out the Malarkey. No matter what we do, we'll always ask, is there a simpler way? In our new TV advert, we challenge those moments of everyday Malarkey.",
  plansHeading: 'Check out our plans',
  viewAllPlans: 'View all plans',
  pageTitle: 'Less Malarkey More SMARTY',
}
